<ng-template cdk-portal="">
  <div class="wrapper" [class.scrollable]="scrollable">
    <ng-content></ng-content>
  </div>
</ng-template>